<app-confirmation-dialog [props]="confirmationDialogProps" id="portfolio-mgr-dialog">
  <form class="container-fluid" id="portfolio-mgr-form">
    <div class="wallet-content">
      <div class="input-container">
        <label for="portfolio-mgr-input-name" i18n="@@name" id="portfolio-mgr-label-name">
          Nombre
        </label>
        <input
          #nameInput
          [appInputRegex]="'^[a-zA-Z0-9_\\s]*$'"
          appMaxlengthEnforcer="50"
          autofocus
          type="text"
          class="form-control form-control-sm"
          id="portfolio-mgr-input-name"
          (input)="onNameChange($event)"
          [(ngModel)]="wallet.name"
          name="walletName"
          placeholder="Nome da Carteira"
          required
          />
          @if (!wallet.name) {
            <div class="invalid-value-text-info" i18n="@@nameRequired" id="portfolio-mgr-error-name-required">
          * Nombre requerido
        </div>
          }
          @if (!maxMinLength) {
            <div class="invalid-value-text-info" i18n="@@min3max5Characters" id="portfolio-mgr-error-name-length">
          * Mínimo 3 máximo 50 caracteres
        </div>
          }
        </div>

        @if (flagEnablePlans) {
          <div class="input-container" id="portfolio-mgr-plan-container">
            <div class="label-with-icon" id="portfolio-mgr-plan-label-wrapper">
              <label for="portfolio-mgr-select-plan" i18n="@@plan" id="portfolio-mgr-label-plan">Plan</label>
              @if (showPlanIcon) {
                <app-icon
                  id="portfolio-mgr-icon-help-plan"
                  cdkOverlayOrigin
                  #originOverlay="cdkOverlayOrigin"
                  name="help_outlined"
                  size="18"
                  alt="Help icon"
                  (mouseenter)="showPlanTooltip = true"
                  (mouseleave)="showPlanTooltip = false">
                </app-icon>
              }
              <ng-template
                cdkConnectedOverlay
                [cdkConnectedOverlayOpen]="showPlanTooltip"
                [cdkConnectedOverlayOrigin]="originOverlay"
                [cdkConnectedOverlayPositions]="toolTipPosstions"
                >
                <div class="tooltip-box" id="portfolio-mgr-plan-tooltip-box">
                  <ng-container>
                    <div class="tooltip-title" id="portfolio-mgr-plan-tooltip-title">{{ selectedPlan.name }}</div>
                    <div class="tooltip-subtitle" i18n="@@planIndicatorSubtitle" id="portfolio-mgr-plan-tooltip-subtitle">Atributos</div>
                    @if (planIndicators.length > 0) {
                      <ul id="portfolio-mgr-plan-tooltip-list">
                        @for (planIndicator of planIndicators; track planIndicator; let iPlan = $index) {
                          <li id="portfolio-mgr-plan-tooltip-item-{{iPlan}}">
                            {{ planIndicator.indicator.name }}
                          </li>
                        }
                      </ul>
                    } @else {
                      <div class="tooltip-no-indicators-message" i18n="@@planWIthoutIndicator" id="portfolio-mgr-plan-tooltip-empty">
                    Este plan no tiene atributos.
                  </div>
                    }
                  </ng-container>
                </div>
              </ng-template>
            </div>
            @if (plans && plans.length > 0) {
              <div id="portfolio-mgr-select-plan-wrapper">
                <select class="form-control form-control-sm"
                  id="portfolio-mgr-select-plan"
                  name="plan"
                  required
                  [disabled]="!isCreating"
                  [(ngModel)]="selectedPlan"
                  (ngModelChange)="selectPlan($event)"
                  >
                  @for (plan of plans; track plan; let iPlanOpt = $index) {
                    <option [ngValue]="plan" id="portfolio-mgr-option-plan-{{iPlanOpt}}">
                      {{plan.name}}
                    </option>
                  }
                </select>
                @if (isCreating && !selectedPlan) {
                  <div class="invalid-value-text-info" i18n="@@planRequired" id="portfolio-mgr-error-plan-required">
            * Plan requerido
          </div>
                }
              </div>
            } @else {
              <select id="portfolio-mgr-select-plan-loading" required disabled>
                <option id="portfolio-mgr-option-plan-loading">Carregando plano...</option>
              </select>
            }
          </div>
        }

        <app-icon
          id="portfolio-mgr-btn-favorite"
          style="cursor: pointer;" size="28"
          color="#597d26"
          [name]="wallet.favorite ? 'star' : 'star_outlined'"
          (click)="toggleFavorite()"
          tabindex="0"
          >
        </app-icon>
      </div>
    </form>
  </app-confirmation-dialog>
